// extracted by mini-css-extract-plugin
export default {"container":"phnumber_container__sM2AE","box":"phnumber_box__K10eP","Number":"phnumber_Number__tzQ7c","call":"phnumber_call__Xlgem"};